import React, { useEffect, useState } from "react";
import { NavigationalButtons } from "./CreateAudioWizard";
import { Form, Formik } from "formik";
import useAxios from "axios-hooks";

import TextField from "../../../../Forms/TextField";

const SEOStep = ({ audioId, nextOnClick, prevOnClick, audio}) => {

    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `resources/audio/${audioId}/seo`,
            method: "put",
        },
        { manual: true }
    );
    return (
        <div>
            <Formik
                initialValues={{ seoPageTitle: audio.seoPageTitle, seoMetaDescription: audio.seoMetaDescription }}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                <Form>
                    <TextField
                    label="Page Title"
                    name="seoPageTitle"
                    className="mt-0"
                    required
                    />

                    <TextField
                    label="Meta Description"
                    name="seoMetaDescription"
                    required
                    />

                    <NavigationalButtons
                        loading={submitting}
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default SEOStep;
